import React from 'react';
import ArrayInput from './ArrayInput';

const RequirementsSection = ({
  jobData,
  newRequirement,
  setNewRequirement,
  newResponsibility,
  setNewResponsibility,
  handleRequirementAdd,
  handleRequirementRemove,
  handleResponsibilityAdd,
  handleResponsibilityRemove
}) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">Requirements & Responsibilities</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <ArrayInput
          label="Requirements"
          arrayName="requirements"
          items={jobData.requirements}
          newValue={newRequirement}
          onValueChange={setNewRequirement}
          onAdd={handleRequirementAdd}
          onRemove={handleRequirementRemove}
          placeholder="Add a requirement..."
        />

        <ArrayInput
          label="Responsibilities"
          arrayName="responsibilities"
          items={jobData.responsibilities}
          newValue={newResponsibility}
          onValueChange={setNewResponsibility}
          onAdd={handleResponsibilityAdd}
          onRemove={handleResponsibilityRemove}
          placeholder="Add a responsibility..."
        />
      </div>
    </div>
  );
};

export default RequirementsSection;